/**
 * Kreditbe kerülő funkciók — egy helyen a címkék és részletes magyarázatok (ⓘ popover).
 * Bekapcsolt kiegészítőre újra kattintva kikapcsolható (kredit visszatérítés nélkül).
 */
export const CREDIT_ADDONS = {
  listing_upload: {
    label: "Hirdetés feladása",
    shortDesc: "Egyszeri díj új hirdetés létrehozásakor",
    helpTitle: "Egyszeri feladási díj",
    help: `Amikor új autót adsz fel, egyszer levonódik a kreditből.

• A hirdetés a fiókodban jelenik meg
• Admin jóváhagyás után kerül a nyilvános készletbe
• Szerkesztheted, képeket cserélhetsz — újra feladni nem kell`,
  },
  listing_daily: {
    label: "Napi fenntartás",
    shortDesc: "Minden nap, amíg a hirdetés aktív",
    helpTitle: "Napi fenntartási díj",
    help: `Minden nap automatikusan levonódik, amíg a hirdetésed „él” és van elég kredited.

• Ha elfogy a kredit, a hirdetés lekerülhet a kínálatból
• A /kreditek oldalon tölthetsz fel új egyenleget
• A napi díj független a heti kiemelésektől`,
  },
  viewer_360: {
    label: "360° körbeforgatás",
    shortDesc: "Körbejáró videó → húzható körbenézés",
    helpTitle: "360° körbeforgatás",
    help: `Egyszeri kiegészítő: bekapcsolod autónként, majd a hirdetés szerkesztésében felveszed a körbejáró videót (~25 mp, vízszintes telefon). Stabilizálás + sima körbenézés.

• Vevő: a képen balra–jobbra húzva forgathat
• „360°” jelvény a kártyán
• Csak az app kamerája — nincs külső fájl
• Egyszeri kredit, a hirdetés ideje alatt aktív`,
  },
  ai_photo_bg: {
    label: "AI háttércsere",
    shortDesc: "Beton stúdió — külső és belső képek",
    helpTitle: "AI háttércsere",
    help: `Galéria fotók mögé egységes beton stúdió — az autó és a belső marad.

• Külső és belső kép is feldolgozható; ablakon át ugyanaz a stúdió látszik
• Bekapcsoláskor vagy később újrafuttatható; eredeti képek visszaállíthatók
• Egy prémium beton stúdió preset — lágy fény, természetes árnyék
• Eredeti képek megmaradnak — előnézet, visszaállítás; újrafuttatás opcionálisan az eredetiből
• Legjobb eredmény: éles fotó, jól látható autó, egyszerű eredeti háttér
• Egyszeri kiegészítő a hirdetéshez`,
  },
  facebook_crosspost: {
    label: "Facebook Marketplace és csoportok",
    shortDesc: "Manuális megosztás a csapatunkkal",
    helpTitle: "Facebook Marketplace és csoportok",
    help: `Egyszeri szolgáltatás: kérésre közzétessük az autódat a Facebook Marketplace-en és releváns magyar autó-eladó csoportokban.

• A hirdetésed linkjét és fotóit használjuk
• A csapat manuálisan készíti és posztolja — nem automata API
• Ismételhető: frissítés vagy új kampány esetén újra megrendelheted
• Egyszeri díj kérésenként (admin árazásban módosítható)

Nem ugyanaz, mint a fizetős Meta hirdetés kiegészítő — ez organikus megosztás.`,
  },
  ai_customer_support: {
    label: "AI ügyfélszolgálat",
    shortDesc: "Automata válaszok érdeklődőknek",
    helpTitle: "AI ügyfélszolgálat",
    help: `A vevő chatben kérdez — az AI rövid, releváns választ ad a nyilvános adatlap + privát brief alapján.

• Nem válaszol minden üzenetre (pl. köszönés, „ok”) — csak ha van érdemi kérdés
• A gyakori kérdésekre kitöltött válaszokból gyakran azonnal tud segíteni LLM nélkül is
• Megtekintés: javaslatot ad, te erősíted meg push/e-mailben
• Te bármikor átveszed a beszélgetést — ha nemrég írtál, az AI hátrébb lép
• Egyszeri aktiválás hirdetésenként`,
  },
  list_boost: {
    label: "Kiemelés a listában",
    shortDesc: "Kék keret + AI címkék 7 napig (sorrend változatlan)",
    helpTitle: "Kiemelés a listában — mit jelent?",
    help: `Vizuális kiemelés — a vevők jobban észreveszik a hirdetésed, de a keresési sorrend nem változik.

• Pulzáló kék keret a kártyán (nincs külön „Kiemelt” jelvény)
• Legfeljebb 3 rövid címke futószalagban a fotó alján — AI vagy szabályalapú, csak valós adatokból
• Hirdetés mentésekor a címkék frissülnek
• 7 napig érvényes; lejárat után újra aktiválható
• Lista elejére a „Kiemelt rangsorolás (TOP)” kiegészítővel kerülhetsz

Tipp: ha sok a verseny, kombináld a TOP-pal.`,
  },
  priority_ranking: {
    label: "Kiemelt rangsorolás",
    shortDesc: "Lista eleje, TOP jelvény 7 napig",
    helpTitle: "Kiemelt rangsorolás — mit jelent?",
    help: `A keresési találatok és az „Ajánlott” rendezés **tetején** jelenik meg a hirdetésed.

• „TOP” jelvény a kártyán
• Több megye / márka szűrő mellett is elöl maradsz
• 7 napig érvényes (hetente megújítható)
• Rangsorban prioritást kapsz (a sima listakiemelés nem mozgatja a sorrendet)

Ideális, ha gyorsan több megtekintést szeretnél.`,
  },
  meta_ads: {
    label: "Meta hirdetés",
    shortDesc: "Kérés Meta (Facebook/Instagram) kampányindításra",
    helpTitle: "Meta hirdetés",
    help: `Heti kiegészítő: kérést küldünk az admin csapatnak Meta (Facebook/Instagram) hirdetés indítására.

• A csapat felveszi veled a kapcsolatot
• Külön kampányköltség a Meta platformon — ez a kredit csak a szolgáltatás kérése
• 7 napos időszakra vonatkozik
• Egyedi autó vagy teljes készlet promotálása`,
  },
  detailed_stats: {
    label: "Részletes statisztika",
    shortDesc: "Napi megtekintés és érdeklődés grafikon",
    helpTitle: "Részletes statisztika",
    help: `Autónként kapcsolható — csak bekapcsolt hirdetésnél látszik a napi grafikon a fiókban.

• Megtekintések és érdeklődések idővonala (7 / 14 / 30 nap)
• Napi kredit / autó, amíg be van kapcsolva (a napi fenntartás mellett) — nincs egyszeri aktiválási díj
• Ki/bekapcsolható a hirdetés Kiegészítők paneljén
• A fiók grafikonján látszik az ár és hogy aktiválható
• Teljesítménygarancia: 14 nap statisztika után, ha senki nem érdeklődött VAGY kevesebb mint 10 megtekintés volt, egyszer 60 kredit ajándék (autónként egyszer)`,
  },
};

export function getAddonInfo(key) {
  return CREDIT_ADDONS[key] || null;
}
